import Config from 'configuration';

export default function getImagePath({ icon, type }) {
  const imageIcon = (icon) || 'placeholder2';

  if (type === 'cameo') {
    return `${Config.imageUrl}cameos/${imageIcon}.png`;
  }
  if (type === 'lodgings') {
    return `${Config.imageUrl}lodgings/${imageIcon}.png`;
  }
  if (type === 'currencies') {
    return `${Config.imageUrl}currencies/${imageIcon}.png`;
  }
  if (type === 'card') {
    return `${Config.imageUrl}cards/${imageIcon}.png`;
  }
  if (type === 'small-icon') {
    return `${Config.imageUrl}icons_small/${imageIcon}.png`;
  }
  if (type === 'location') {
    return `${Config.imageUrl}locations/${imageIcon}.jpg`;
  }
  if (type === 'ad') {
    return `${Config.bucketUrl}ads/${imageIcon}.png`;
  }
  return `${Config.imageUrl}icons/${imageIcon}.png`;
}